/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.ActivityLog{
    'use strict';

    interface IScope extends ng.IScope{
        item: any,
        searchString: string
    }

    export class ActivityLogTableDirective implements angular.IDirective{
        restrict = 'E';
        template = `
            <div flex="20" flex-sm="30" layout="row" layout-align="start center" data-header="{{'LABEL_DAY_DATE_TIME' | translate}}" hide-xs>
                {{ item.dateTime | meevoDateTimeFilter }}
            </div>
            <div flex="15" layout="row" layout-align="start center" data-header="{{'LABEL_USER_ID' | translate}}" hide-xs>
                {{ item.userId }}
            </div>
            <div flex layout="row"
                 layout-align="start center"
                 data-header="{{'LABEL_DESCRIPTION' | translate}}"
                 hide-xs>
                <div ng-bind-html="item.description | highlight:searchString" class="text-ellipsis"></div>
            </div>
            <div flex="20" layout="row" layout-align="start center" data-header="{{'LABEL_APPLICATION' | translate}}" hide-xs>
                {{ item.application }}
            </div>
            <div hide-gt-xs layout="row">
                <div translate="LABEL_DAY_DATE_TIME" class="bold"></div>&#58;&nbsp;
                <div>{{ item.dateTime | meevoDateTimeFilter }}</div>
            </div>
            <div hide-gt-xs layout="row">
                <div translate="LABEL_USER_ID" class="bold"></div>&#58;&nbsp;
                <div>{{ item.userId }}</div>
            </div>
            <div hide-gt-xs layout="row">
                <div translate="LABEL_DESCRIPTION" class="bold" flex="none"></div>&#58;&nbsp;
                <div ng-bind-html="item.description | highlight:searchString" class="text-ellipsis"></div>
            </div>
            <div hide-gt-xs layout="row">
                <div translate="LABEL_APPLICATION" class="bold"></div>&#58;&nbsp;
                <div>{{ item.application }}</div>
            </div>
        `;
        scope = {
            item: '=',
            searchString: '='
        };

        constructor() {

        }

        link = (scope: IScope, element: JQuery) => {

        };

        static factory(): angular.IDirectiveFactory {
            let directive = ($rootScope) => {
                return new ActivityLogTableDirective();
            };
            directive.$inject = ["$rootScope"];
            return directive;
        }
    }

    angular.module('meevo.plugins.activityLog')
        .directive('activityLogTable', ActivityLogTableDirective.factory());
}
